export const discordJumpLinkMap = {
    'en': 'https://discord.gg/WfzpSbaUFa',
    'de': 'https://discord.gg/WfzpSbaUFa',
    'fr': 'https://discord.gg/WfzpSbaUFa',
}
